import { Button } from '@/components/ui/button.js';

interface CatalogEmptyStateProps {
  hasFilters: boolean;
  onClearFilters: () => void;
}

export function CatalogEmptyState({ hasFilters, onClearFilters }: CatalogEmptyStateProps) {
  return (
    <output
      aria-live="polite"
      className="flex flex-col items-center justify-center py-20 text-center"
    >
      <div className="mb-4 text-4xl" aria-hidden="true">
        🔍
      </div>
      <h2 className="mb-2 text-lg font-semibold text-[var(--color-qup-text-dark)]">
        Ningún informe encontrado
      </h2>
      <p className="mb-6 max-w-sm text-sm text-[var(--color-qup-text-muted-dark)]">
        {hasFilters
          ? 'Prueba a cambiar los filtros o elimínalos para ver todos los informes.'
          : 'No hay informes disponibles en este catálogo.'}
      </p>
      {hasFilters && (
        <Button variant="secondary" size="sm" onClick={onClearFilters}>
          Limpiar filtros
        </Button>
      )}
    </output>
  );
}
